// import fetch from '../libs/fetch';
import {
    CAR_LISTING_VALIDATION_TAG,
    COMMON_SERVER_HEADERS,
    DEFAULT_LANGUAGE,
    NEXT_APP_SERVER_FETCH_CACHE_ENABLED,
    RETAIL_BACKEND,
} from '@/constants';
import { GetBanners, GetCarListing } from '@/types';
import { TIME_IN_SECONDS } from '@/constants/time';
import To from '@/libs/to-promise';
import pino from 'pino';
const logger = pino().child({ s: 'src/api-requests/car-listing.apis.ts' });

export async function getCarListings({
    lang = DEFAULT_LANGUAGE,
}): Promise<GetCarListing> {
    let requestOptions: RequestInit = {
        next: { revalidate: 0 },
        headers: {
            ...COMMON_SERVER_HEADERS,
            lang: lang,
        },
    };
    if (NEXT_APP_SERVER_FETCH_CACHE_ENABLED) {
        requestOptions.next = { tags: [CAR_LISTING_VALIDATION_TAG] };
    }
    logger.info(
        `Going to fetch car list params are ${JSON.stringify(requestOptions)}`
    );
    const [err, res] = await To(
        fetch(`${RETAIL_BACKEND}/vehicles/retail/public`, requestOptions)
    );
    if (err) {
        logger.error(err);
        return {} as GetCarListing;
    }
    let [dataParseError, data] = await To(res.json());
    if (dataParseError) {
        logger.info('Error while trying to parse  getCarListings response.');
        logger.info('original data provided is ', data);
        logger.error(dataParseError);
        return {} as GetCarListing;
    }
    return data;
}

export async function getBanners(): Promise<GetBanners> {
    const [err, res] = await To(
        fetch(`${RETAIL_BACKEND}/banners/public`, {
            headers: { ...COMMON_SERVER_HEADERS },
            next: {
                revalidate:
                    TIME_IN_SECONDS.minute *
                    30 *
                    Number(NEXT_APP_SERVER_FETCH_CACHE_ENABLED),
            },
        })
    );
    if (err) {
        logger.info(err);
        return {} as GetBanners;
    }
    let [dataParseError, data] = await To(res.json());
    if (dataParseError) {
        logger.info('Error while trying to parse car imperfection response.');
        logger.info('original data provided is ', data);
        logger.error(dataParseError);
        return {} as GetBanners;
    }
    return data;
}
